/**
 * In-memory bearer token store. The token lives only in a module-level
 * closure — never in cookies, localStorage, or sessionStorage. This
 * makes it immune to third-party cookie blocking and minimizes XSS
 * exposure (cleared on tab close, not persisted to disk).
 */

let _bearerToken: string | null = null;

export function setBearerToken(token: string): void {
  _bearerToken = token;
}

export function getBearerToken(): string | null {
  return _bearerToken;
}

export function clearBearerToken(): void {
  _bearerToken = null;
}
